import { useIsBodyScrollLocked } from '@/hooks/useBodyScrollLock';

/**
 * useOverlayOpen
 *
 * "A modal / drawer / sheet is open" signal for floating widgets (onboarding
 * checklist, system notification banner) that must never cover an overlay's
 * footer. Reads the ref-counted scroll-lock SSOT in useBodyScrollLock.
 */
export function useOverlayOpen(): boolean {
  return useIsBodyScrollLocked();
}
